/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSimilarItemsLanding_user = {
    readonly serviceId: string | null;
    readonly " $refType": "PdpRespSimilarItemsLanding_user";
};
export type PdpRespSimilarItemsLanding_user$data = PdpRespSimilarItemsLanding_user;
export type PdpRespSimilarItemsLanding_user$key = {
    readonly " $data"?: PdpRespSimilarItemsLanding_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsLanding_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsLanding_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'efd46591c1c72ad3241e91524989dba3';
export default node;
